export enum GuestLogType {
  // Guest CRUD
  CREATE = "CREATE",
  DELETE = "DELETE",
  UPDATE = "UPDATE",
  NOTE = "NOTE",
  NOTE_EDIT = "NOTE_EDIT",
  DELETE_COMPANION = "DELETE_COMPANION",

  // Companion
  COMPANION_ADDED = "COMPANION_ADDED",
  COMPANION_REMOVED = "COMPANION_REMOVED",

  // Check-in
  CHECK_IN = "CHECK_IN",
  CHECK_OUT = "CHECK_OUT",

  // Waitlist
  WAITLISTED = "WAITLISTED",
  PROMOTED = "PROMOTED",
  WAITLIST_JOINED = "WAITLIST_JOINED",
  WAITLIST_CANCELLED = "WAITLIST_CANCELLED",

  // Appointments
  APPOINTMENT_CREATED = "APPOINTMENT_CREATED",
  APPOINTMENT_UPDATED = "APPOINTMENT_UPDATED",
  APPOINTMENT_CANCELLED = "APPOINTMENT_CANCELLED",
  APPOINTMENT_CONFIRMED = "APPOINTMENT_CONFIRMED",
  APPOINTMENT_DECLINED = "APPOINTMENT_DECLINED",
  APPOINTMENT_CHECK_IN = "APPOINTMENT_CHECK_IN",
  APPOINTMENT_RESCHEDULED = "APPOINTMENT_RESCHEDULED",

  // Seating
  SEATED = "SEATED",
  UNSEATED = "UNSEATED",
  SEATING_CHECK_IN = "SEATING_CHECK_IN",

  // Communication
  EMAIL_SENT = "EMAIL_SENT",
  // SMS channel wave: written by the consumer after AWS accepted a guest-mode
  // SMS (never in dryrun). MIRROR: main-backend GuestLogType.SMS_SENT.
  SMS_SENT = "SMS_SENT",

  // Portal
  PORTAL_VISITED = "PORTAL_VISITED",
  PORTAL_DOWNLOADED = "PORTAL_DOWNLOADED",

  // Ticket portal (`/p/:token`, portal-backend) — NOT the website above.
  // One visit row per link per 30 min; the wallet row is a TAP on the button.
  TICKET_PORTAL_VISITED = "TICKET_PORTAL_VISITED",
  TICKET_WALLET_CLICKED = "TICKET_WALLET_CLICKED",

  // Website
  WEBSITE_LOGIN = "WEBSITE_LOGIN",

  // Archive
  ARCHIVED = "ARCHIVED",
  UNARCHIVED = "UNARCHIVED",

  // W6 guest trash (main-backend GuestLogType.RESTORED): the guest came back
  // from the trash. `field` may carry the regenerated username (⚑10/⚑16) — a
  // label, not a before/after.
  RESTORED = "RESTORED",

  // Requests
  REQUEST_APPROVED = "REQUEST_APPROVED",
  REQUEST_DENIED = "REQUEST_DENIED",
  REQUEST_SUBMITTED = "REQUEST_SUBMITTED",

  // Logins
  QR_LOGIN = "QR_LOGIN",

  // Workflow (main-backend GuestLogType, WB audit 1b 2026-09-23): the Worker
  // could not send a registration's workflow trigger; `field` = "trigger",
  // `newValue` = the trigger NAME. No replay job exists yet — these rows are the
  // ops alert anchor for a lost automation (2026-09-23 audit 1b).
  WORKFLOW_TRIGGER_LOST = "WORKFLOW_TRIGGER_LOST",

  // Meta
  IMPORTED = "IMPORTED",
  CLONED = "CLONED",
  EXPORTED = "EXPORTED",
  CONTACTED = "CONTACTED",
  INVITATION_USED = "INVITATION_USED",
}
